import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { FaCheck, FaEye } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import apiClient, {
  initializeApiClient,
  setAuthToken,
} from "../../api/apiClient";
import { login } from "../../redux/counterSlice";

export default () => {
  const dispatch = useDispatch();
  const { profile_url, setProfile_url } = useOutletContext();
  const state = useSelector((state) => state.auth);
  const userId = useSelector((state) => state.auth.userId);

  const initialState = {
    driver_license_url: null,
    email: "",
    first_name: "",
    last_name: "",
    usdot_number: "",
    address: "",
    phone_number: "",
  };

  const [owner, setOwner] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [driverLicensePreview, setDriverLicensePreview] = useState(null);
  const [showLicenseModal, setShowLicenseModal] = useState(false);

  const handleChange = (key, value) => {
    setOwner((prevOwner) => ({ ...prevOwner, [key]: value }));
    if (key === "driver_license_url" && value instanceof File) {
      setDriverLicensePreview(URL.createObjectURL(value));
    }
  };

  const fetchUserData = async () => {
    try {
      initializeApiClient();
      const response = await apiClient.get("/authentication/accounts/");
      const data = response.data;
      setAuthToken(data?.token);
      console.log(data);
      if (response.status === 200) {
        let usdotNumber = "";
        if (data?.usdot_number) {
          usdotNumber = data.usdot_number.replace(/[\[\]']/g, "").trim();
        }

        let phoneNumber = "";
        if (data?.phone_number) {
          phoneNumber = data.phone_number
            .replace(/^\+1/, "")
            .replace(/\D/g, "");
        }

        setProfile_url(data?.profile_url || null);
        setOwner((prevOwner) => ({
          ...prevOwner,
          driver_license_url: data?.driver_license_url || null,
          email: data?.email || "",
          first_name: data?.first_name || "",
          last_name: data?.last_name || "",
          usdot_number: usdotNumber,
          address: data?.address || "",
          phone_number: phoneNumber,
        }));
        dispatch(
          login({
            ...state,
            name: data?.first_name || "",
          })
        );
      } else {
        console.error(
          "Error fetching user data: Unexpected response structure"
        );
        toast.error("Failed to fetch user data. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error(
        "An error occurred while fetching user data. Please try again."
      );
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    if (owner?.driver_license_url instanceof File) {
      formData.append("driver_license_url", owner.driver_license_url);
    }
    if (profile_url instanceof File) {
      formData.append("profile_url", profile_url);
    }
    formData.append("email", owner.email);
    formData.append("first_name", owner.first_name);
    formData.append("last_name", owner.last_name);
    formData.append("usdot_number", owner.usdot_number);
    formData.append("address", owner.address);
    formData.append("phone_number", owner.phone_number);

    const formattedPhone = owner.phone_number.startsWith("+1")
      ? owner.phone_number
      : `+1${owner.phone_number}`;

    const formattedUSDOT = `['${owner.usdot_number}']`;

    formData.append("phone_number", formattedPhone);
    formData.append("usdot_number", formattedUSDOT);

    try {
      initializeApiClient();
      const result = await apiClient.patch(
        `/authentication/accounts/${userId}/`, // Include userId in the URL
        formData
      );
      if (result.status === 200) {
        setLoading(false);
        toast.success("Account info Successfully Updated");
        // Refresh user data after successful update
        fetchUserData();
      } else {
        setLoading(false);
        toast.error("Error updating account info");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating account info:", error);
      toast.error("Error updating account info");
    }
  };

  const handleViewLicense = () => {
    setShowLicenseModal(true);
  };

  const LicenseModal = () => (
    <div
      className="modal"
      style={{ display: showLicenseModal ? "block" : "none" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Driver's License</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowLicenseModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <img
              src={driverLicensePreview || owner.driver_license_url}
              alt="Driver's License"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <div className="input-fields">
                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-1 fs-5">
                    <label className="label blue-clr m-1" htmlFor="license">
                      Driver's License
                    </label>
                    <div className="d-flex align-items-center">
                      <label
                        className="form-control licence_bg m-1 px-2 py-1 fs-4 file-input text-center flex-grow-1"
                        htmlFor="license"
                      >
                        {owner?.driver_license_url || driverLicensePreview ? (
                          <div
                            className="file-uploaded-text"
                            style={{ padding: "6px 0px" }}
                          >
                            File uploaded
                          </div>
                        ) : (
                          <i className="bi p-0 bi-image-fill" />
                        )}
                        <input
                          hidden
                          type="file"
                          accept="image/*"
                          className="form-control m-1 px-2 py-1 fs-4"
                          id="license"
                          onChange={(e) =>
                            handleChange(
                              "driver_license_url",
                              e.target.files[0]
                            )
                          }
                        />
                        {driverLicensePreview && (
                          <img
                            src={driverLicensePreview}
                            alt="Driver's License Preview"
                            style={{ maxWidth: "100%", marginTop: "10px" }}
                          />
                        )}
                      </label>
                      {(owner?.driver_license_url || driverLicensePreview) && (
                        <button
                          type="button"
                          className="btn btn-primary ms-2"
                          onClick={handleViewLicense}
                        >
                          <FaEye />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-1 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Email">
                      Email
                    </label>
                    <input
                      type="email"
                      value={owner?.email}
                      onChange={(e) => handleChange("email", e.target.value)}
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="Email"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="First-name">
                      First Name
                    </label>
                    <input
                      type="text"
                      value={owner?.first_name || ""}
                      onChange={(e) =>
                        handleChange("first_name", e.target.value)
                      }
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="First-name"
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="usdot_number"
                    >
                      USDOT Number
                    </label>
                    <input
                      type="number"
                      value={owner?.usdot_number}
                      onChange={(e) =>
                        handleChange("usdot_number", e.target.value)
                      }
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="usdot_number"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Last-name">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="Last-name"
                      value={owner?.last_name}
                      onChange={(e) =>
                        handleChange("last_name", e.target.value)
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="Phone-Number"
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      value={owner?.phone_number}
                      onChange={(e) =>
                        handleChange("phone_number", e.target.value)
                      }
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="Phone-Number"
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-center">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="address">
                      Address
                    </label>
                    <input
                      type="text"
                      value={owner?.address}
                      onChange={(e) => handleChange("address", e.target.value)}
                      className="form-control m-1 px-2 py-1 fs-4"
                      id="address"
                    />
                  </div>
                </div>
              </div>
              <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                {!loading ? (
                  <button
                    type="submit"
                    className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                  >
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>
                ) : (
                  <div className="text-center mt-3">
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <LicenseModal />
    </div>
  );
};
